import React from 'react';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Credentials from './components/Credentials';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <ValueProposition />
      <Services />
      <HowItWorks />
      <Credentials />
      <Portfolio />
      <Testimonials />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default App;
